import { connect } from 'react-redux'
import StationUserTripDashboard from '../../components/station-user-trips/StationUserTripDashboard'
import * as actions from '../../state/actions/trips'
import { getManyTrips } from '../../state/actions/station-user-trips'
import { showOrgServiceArea, actionCreators as mapsActionCreators } from '../../state/actions/google_map'
import { getGoinzones } from '../../state/actions/goinzones'
import { IStoreState, ITripFilters, IRiderTrip, IPagination, IStationUserTripFilters } from '../../types'
import moment from 'moment'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  return {
    currentUserId: state.user.currentUserId,
    orgId: state.organizations.currentOrgId,
    isFetching: state.trips.isFetching,
    zones: state.goinzones.items,
    trips: state.stationUserTrips.items,
    tripFilters: state.trips.filters
  }
}

export function mapDispatchToProps(dispatch: any, ownProps: any) {
  return {
    showOrgServiceArea: () => dispatch(showOrgServiceArea()),
    fetchTrips: (filters: IStationUserTripFilters, currentUserId: string) => {
      return dispatch(getManyTrips(filters, currentUserId))
    },
    filterTripsByZone: (payload: ITripFilters) => {
      if (!payload.orgId && payload.zoneId) {
        return
      }

      return dispatch(actions.filterByZone(payload))
    },

    updateTripFilters: (filters: ITripFilters) => {
      return dispatch(actions.actionCreators.updateTripFilters(filters))
    },

    getGoinzones: (orgId: string) => {
      return dispatch(getGoinzones(orgId))
    },

    cloneTrip: async (trip: IRiderTrip) => {
      const tripClone = { ...trip }
      const pickup = {
        lat: trip.pickupLocation.latitude,
        lng: trip.pickupLocation.longitude
      }
      const dropoff = {
        lat: trip.dropoffLocation.latitude,
        lng: trip.dropoffLocation.longitude
      }
      tripClone.product = { id: '', name: '', pricingId: '' }
      tripClone.rider = undefined
      tripClone.scheduledPickupTime = moment().toISOString()
      tripClone.scheduledDropoffTime = undefined

      return Promise.all([
        dispatch(actions.actionCreators.cloneTrip(tripClone)),
        dispatch(mapsActionCreators.setOrigin(pickup)),
        dispatch(mapsActionCreators.setDestination(dropoff)),
        dispatch(mapsActionCreators.replaceMarkers('origin', [{ type: 'origin', lat: pickup.lat, lng: pickup.lng }])),
        dispatch(
          mapsActionCreators.replaceMarkers('destination', [
            { type: 'destination', lat: dropoff.lat, lng: dropoff.lng }
          ])
        )
      ])
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationUserTripDashboard)



// WEBPACK FOOTER //
// ./src/containers/station-user-trips/StationUserTripsDashboard.ts